<template>
  <!-- <div> -->
  <b-container
    fluid
    class="col-12 border-secondary mx-auto border__div px-0 pt-0 mb-4 conversazione"
    v-if="destinatario"
  >
    <h4 class="font-weight-bold mt-2">
      {{
      destinatario.tipologia === "professionista"
      ? "Dr. " + destinatario.anagrafica.fullname
      : destinatario.anagrafica.fullname
      }}
    </h4>
    <div class="pr-3 conv__container" v-if="!loading">
      <!-- <div class="d-flex flex-column px-2 overflow__box__m"> -->
      <p
        v-if="!noMore"
        class="text-center text-primary mb-0 point"
        @click="loadMore"
      >Carica altri messaggi..</p>
      <transition-group tag="div" name="list" class="d-flex flex-column px-2 overflow__box__m">
        <div
          v-for="(msg, ind) in prevMsg"
          :key="ind"
          class="col-12"
          :class="
            msg.destinatario.hashid == user.hashid &&
              msg.letto == false &&
              'unseen__smg'
          "
        >
          <div v-if="msg.destinatario.hashid === destinatario.hashid">
            <h6 class="text-right text-secondary px-4 pb-1">Tu</h6>
            <div class="text-black col-12 my-2 py-2 bg__right bg-grey">
              <p class="text-right my-1 pr-2">{{ msg.messaggio }}</p>
              <p
                class="text-right mb-0 px-2 text-dark-grey"
              >{{ msg.created_at | moment("dddd D MMMM HH:mm") }}</p>
            </div>
          </div>
          <div v-else>
            <h6 class="text-left text-secondary px-4 pb-1">
              {{
              destinatario.tipologia === "professionista"
              ? "Dr. " + destinatario.anagrafica.fullname
              : destinatario.anagrafica.fullname
              }}
            </h6>
            <div class="text-white col-12 my-2 py-2 bg__left bg-secondary">
              <p class="text-left my-1 pl-2">{{ msg.messaggio }}</p>
              <p
                class="mb-0 text-left px-2 text-dark-grey"
              >{{ msg.created_at | moment("dddd D MMMM HH:mm") }}</p>
            </div>
          </div>
        </div>
      </transition-group>
      <!-- </div> -->
    </div>
    <div class="col-11 px-0 rounded mt-3 mb-1 py-1 mx-auto bg-grey" v-if="!loading">
      <b-form @submit="sendMsg" v-if="isMobile">
        <div class="d-flex justify-content-center align-items-center msg__icons">
          <div class="col-10 px-0 d-flex justify-content-center align-items-center">
            <b-form-textarea
              id="textarea"
              v-model="form.messaggio"
              placeholder="Scrivi nuovo messaggio..."
              rows="1"
              max-rows="6"
              size="sm"
              class="msg__text noshadow"
            ></b-form-textarea>
          </div>
          <div class="col-2 px-0 d-flex justify-content-center align-items-center">
            <b-spinner v-if="sending" variant="primary m-auto" type="grow"></b-spinner>
            <div class="d-flex justify-content-center align-items-center msg__icons pl-0" v-else>
              <!-- <AttachLogo class="fit__img mr-2" /> -->
              <button type="submit" class="p-0 border-0 send__btn mr-3">
                <InviaLogo class="fit__img" />
              </button>
            </div>
          </div>
        </div>
      </b-form>
      <b-form @submit="sendMsg" v-else>
        <b-row>
          <b-col sm="10">
            <b-form-textarea
              id="textarea"
              v-model="form.messaggio"
              placeholder="Scrivi nuovo messaggio..."
              rows="1"
              max-rows="6"
              size="sm"
              class="msg__text noshadow"
            ></b-form-textarea>
          </b-col>
          <b-col sm="2" class="d-flex justify-content-center align-items-center msg__icons pl-0">
            <b-spinner v-if="sending" variant="primary" type="grow"></b-spinner>
            <div class="d-flex justify-content-center align-items-center msg__icons pl-0" v-else>
              <!-- <AttachLogo class="fit__img mr-2" /> -->
              <button type="submit" class="p-0 border-0 send__btn mr-3">
                <InviaLogo class="fit__img" />
              </button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <br />
  </b-container>
  <!-- </div> -->
</template>
<script>
import InviaLogo from "@/../public/svg/invia.svg";
// import AttachLogo from "@/../public/svg/attach.svg";
export default {
  name: "conversazione",
  props: ["destinatario"],
  components: {
    // AttachLogo
    InviaLogo
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    }
  },
  data() {
    return {
      form: {
        destinatario: null,
        messaggio: null,
        allegati: null
      },
      sending: false,
      prevMsg: [],
      loading: true,
      take: 3,
      nonLetti: [],
      numNonLetti: 0,
      user: null,
      noMore: false,
      total: null
    };
  },
  watch: {
    destinatario: function() {
      // console.log("watcher", val, preVal);
      this.fetchMsg();
    },
    nonLetti: function(val) {
      if ((val.length = this.numNonLetti)) {
        // console.log("ora sì");
        this.segnaComeLetti();
      }
    },
    prevMsg: function(val) {
      // console.log("watch", val);
      var count = Object.keys(val).length;
      // console.log("watch vount", count);

      // console.log("watch total", this.total);
      if (count >= this.total) {
        this.noMore = true;
      } else {
        this.noMore = false;
      }
    }
  },
  methods: {
    sendOnKey() {},
    getUser() {
      var url = process.env.VUE_APP_VERSION + "users/user";
      this.$axios
        .get(url)
        .then(res => {
          // console.log(res.data.data.consenso_notifiche);
          this.user = res.data.data;
          this.fetchMsg();
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    fetchMsg() {
      this.loading = true;
      this.form.destinatario = this.destinatario.hashid;
      // var url =
      //   process.env.VUE_APP_VERSION +
      //   "messaggio/all?destinatario=" +
      //   this.destinatario.hashid;
      var url =
        process.env.VUE_APP_VERSION +
        "messaggio/all?destinatario=" +
        this.destinatario.hashid +
        "&take=" +
        this.take;
      this.$axios
        .get(url)
        .then(res => {
          // console.log("fetch msg response", res.data.data);
          if (!res.data.data.result) {
            this.noMore = true;
            return (this.loading = false);
          }
          this.prevMsg = res.data.data.result;
          this.loading = false;
          this.total = res.data.data.total;
          Object.keys(res.data.data.result).map(msg => {
            // console.log(msg);
            if (
              this.user.hashid ==
                res.data.data.result[msg].destinatario.hashid &&
              res.data.data.result[msg].letto == false
            ) {
              this.nonLetti.push(res.data.data.result[msg].hashid);
              this.numNonLetti++;
            }
          });
          // console.log("obj lentgh", this.prevMsg);
          // console.log("obj lentgh", Object.keys(res.data.data.result).length);
          // if (Object.keys(res.data.data.result).length <= this.take) {
          //   this.noMore = true;
          // } else {
          //   this.noMore = false;
          // }
          //   if (Object.keys(res.data.data.result).length <= this.take) {
          //   this.noMore = true;
          // } else {
          //   this.noMore = false;
          // }

          // console.log("num", this.numNonLetti);
          if (res.data.data.length == 0) {
            //
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    segnaComeLetti() {
      var self = this;
      setTimeout(function() {
        // if (this.nonLetti.length > 0) {
        // console.log("updating");
        var url = process.env.VUE_APP_VERSION + "messaggio/visualizzati";
        var data = { messaggi: self.nonLetti };
        self.$axios
          .put(url, data)
          .then(res => {
            // console.log("segna come letti", res.data.data);
            self.fetchMsg();
          })
          .catch(err => {
            console.log(err);
            if (err.response.status === 401) {
              this.$router.go();
            }
          });
        // }
      }, 3000);
    },
    sendMsg(evt) {
      evt.preventDefault();
      if (this.form.messaggio == null) {
        return;
      }
      this.sending = true;

      var url = process.env.VUE_APP_VERSION + "messaggio";

      this.$axios
        .post(url, this.form)
        .then(res => {
          // console.log(res.data.data);
          this.sending = false;
          this.form.messaggio = null;
          this.$bvToast.toast(
            `Messaggio per ${this.destinatario.anagrafica.fullname} inviato`,
            {
              title: "Messaggio inviato!",
              autoHideDelay: 2000,
              variant: "primary"
            }
          );
          // this.prevMsg.push(res.data.data);
          this.fetchMsg();
        })
        .catch(err => {
          console.log(err);
          this.sending = false;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    loadMore() {
      this.take = this.take + 5;
      this.fetchMsg();
    },
    upload() {
      this.uploading = true;
      var url = process.env.VUE_APP_VERSION + "storage/questionario/img";
      let formData = new FormData();
      formData.append("file", this.file);
      this.$axios
        .post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          // console.log(res);
          this.uploading = false;
          this.btnText = "Salvata!";
          var path = res.data.data;
          this.domande[this.questIndex].a = path;
          // this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.destinatario && this.getUser();
  }
};
</script>
<style>
.conversazione {
  min-height: 350px;

  /* min-width: 250px; */
}
.conversazione div {
  background-repeat: no-repeat;
  border-radius: 1rem;
  background-size: cover;
  min-height: 80px;
}
.bg__left {
  background-position-x: left;
}
.bg__right {
  background-position-x: right;
}
.conv__container > div {
  min-height: 280px;
}
.msg__text {
  border: none !important;
  background-color: #f1f1f1 !important;
  overflow-y: initial !important;
}

.msg__text::-webkit-scrollbar {
  width: 0px !important;
  background: transparent; /* Chrome/Safari/Webkit */
}

.msg__text {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE 10+ */
}
.msg__icons svg {
  max-height: 35px;
  min-width: 27px;
  margin: auto;
  cursor: pointer;
}
.msg__icons svg .bb {
  fill: #fff;
}
.send__btn {
  outline: 0;
  border: 0;
  background-color: transparent;
}
.unseen__smg {
  background-color: #24b98c40;
  transition: all 0.5s;
}
</style>
